module.exports = __webpack_public_path__ + "img/header-cart-img.46a73ab3.svg";